import { gql } from '@apollo/client';

export const UPDATE_PROFILE_INFO = gql`
mutation($record: UpdatePractitionerMeInput!)
{
    user
    {
        dashboardUser
        {
            updateMe(record: $record)
            {
                ok,
                error
                {
                    message,
                    code
                },
                resultId,
                result
                {
                    id,
                    firstName,
                    lastName,
                    email,
                    phone,
                    description,
                    gender,
                    birthDate,
                    preferredLanguages,
                    address
                    {
                        country,
                        city,
                        address,
                        zipcode
                    },
                    professionalNumber,
                    specialities,
                    acts,
                    photoUrl
                }
            }
        }
    }
}
`;
